import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    interrogatorioAS: [],
  },

  getters: {
    getInterrogatorioAS: (state) => state.interrogatorioAS,
  },

  mutations: {
    SET_INTERROGATORIO_AS(state, interrogatorioAS) {
      state.interrogatorioAS = interrogatorioAS;
    },
  },

  actions: {
    async fetchInterrogatorioAS({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/interrogatorioAS`)
        .then((response) => {
          commit('SET_INTERROGATORIO_AS', response.data.data);
        });
    },

    async saveInterrogatorioAS(context, interrogatorioAS) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        interrogatorioAS.map(async (interrogatorio) => {
          const response = await axios.post(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/interrogatorioAS`, interrogatorio);
          return response;
        }),
      );
    },

    async updateInterrogatorioAS(_, interrogatorioAS) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${interrogatorioAS.fk_idHistoriaClinica}/interrogatorioAS/${interrogatorioAS.id}`,
          interrogatorioAS,
        );
    },
  },
};
